// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".placeholder[data-v-5bbc2a6d]{position:absolute;top:0;left:0;z-index:99;transition:.5s;pointer-events:none}@media (max-width:1023px){.placeholder[data-v-5bbc2a6d]{font-size:21px}}", ""]);
// Exports
module.exports = exports;
